module.exports = __webpack_public_path__ + "static/img/icon_jinxingzdds.3618ba47.png";